// src/components/ui/LanguageToggle.tsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { isLanguage } from '../../i18n/translations';

export default function LanguageToggle() {
    const { lang, setLang, availableLanguages } = useLanguage();

    return (
        <select
            value={lang}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => {
                if (isLanguage(event.target.value)) setLang(event.target.value);
            }}
            className="rounded-md border border-neutral-200 bg-white px-2 py-1 text-sm font-medium text-gray-700 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100"
            aria-label="Language"
        >
            {availableLanguages.map((language) => (
                <option key={language.code} value={language.code}>{language.label}</option>
            ))}
        </select>
    );
}
